import { createSelector } from "@reduxjs/toolkit";
import { initialState } from "./campaignManageSlice";

const selectDomain = (state) => state.campaignManage || initialState;

export const makeSelectQuery = createSelector(
  selectDomain,
  (state) => state.query
);

export const makeSelectOne = createSelector(selectDomain, (state) => state.one);

export const makeSelectOfficeType = createSelector(selectDomain, (state) => state.officeType);

export const makeSelectSelectedRetailers = createSelector(
  selectDomain,
  (state) => state.selectedRetailers
);

export const makeSelectSelectedRetailerObj = createSelector(
  selectDomain,
  (state) => state.selectedRetailerObj
);
